import { render } from "./DhSelect.vue?vue&type=template&id=70d31ddd"
import script from "./DhSelect.vue?vue&type=script&lang=ts"
export * from "./DhSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script